import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import ProductTourStep from '@/components/core/productTour/ProductTourStep.vue'
import EmojiPicker from '@/components/core/EmojiPicker.vue'
import LInput from '@/components/core/form/Input.vue'
import { TransportationType } from '@/types/transportation'
import { emojiSuggestionsByTransportationType } from '@/utils/emoji'


export default /*#__PURE__*/_defineComponent({
  __name: 'TransportationEmojiLabelField',
  props: {
    idPrefix: null,
    emoji: null,
    label: null,
    transportationType: null
  },
  emits: ["update:emoji", "update:label"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:emoji', value: string): void
  (e: 'update:label', value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  idPrefix: string
  emoji: string
  label?: string
  transportationType: TransportationType
};





const internalEmoji = computed({
  get() {
    return props.emoji
  },
  set(value) {
    emit('update:emoji', value)
  },
})

const internalLabel = computed({
  get() {
    return props.label ?? ''
  },
  set(value) {
    emit('update:label', value)
  },
})

const suggestedEmojis = computed(() => {
  return emojiSuggestionsByTransportationType[props.transportationType] ?? []
})

return { __sfc: true,props, emit, internalEmoji, internalLabel, suggestedEmojis, ProductTourStep, EmojiPicker, LInput }
}

})